import { Card } from "@/components/ui/card";
import { ExplainDrawer } from "./ExplainDrawer";
import { ArrowUpRight, ArrowDownRight, Info } from "lucide-react";
import { LineChart, Line, ResponsiveContainer } from "recharts";
import { cn } from "@/lib/utils";

export const KpiTile = ({ label, value, sub, delta, deltaDir, spark = [], accent = false, explain, testid }) => (
  <Card className={cn("relative p-5 flex flex-col gap-2 overflow-hidden transition-shadow hover:shadow-md", accent && "ring-1 ring-gold/40")} data-testid={`kpi-tile-${testid}`}>
    <div className="flex items-start justify-between">
      <p className="text-xs uppercase tracking-wide text-muted-foreground">{label}</p>
      {delta != null && (
        <span className={cn("inline-flex items-center gap-0.5 text-xs font-medium", deltaDir === "down" ? "text-sev-success" : "text-sev-warning")}>
          {deltaDir === "down" ? <ArrowDownRight className="h-3 w-3" /> : <ArrowUpRight className="h-3 w-3" />}{delta}
        </span>
      )}
    </div>
    <div className="flex items-end justify-between gap-2">
      <div>
        <p className="font-display text-3xl tabular-nums leading-none">{value}</p>
        {sub && <p className="text-xs text-muted-foreground mt-1.5">{sub}</p>}
      </div>
      {spark.length > 1 && (
        <div className="h-10 w-24">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={spark.map((v, i) => ({ i, v }))}>
              <Line type="monotone" dataKey="v" stroke="hsl(var(--gold))" strokeWidth={1.5} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
    {explain && (
      <ExplainDrawer
        testid={`kpi-${testid}`}
        title={label}
        description={explain.description}
        formula={explain.formula}
        inputs={explain.inputs}
        sources={explain.sources}
        rawRows={explain.rawRows}
        rawCols={explain.rawCols}
        trigger={<button data-testid={`kpi-explain-open-${testid}`} className="mt-1 inline-flex items-center gap-1 self-start text-xs text-muted-foreground hover:text-gold transition-colors"><Info className="h-3 w-3" />Explain</button>}
      />
    )}
  </Card>
);
